// src/pages/reports/AuditRepository.tsx

import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import PageTitle from 'src/components/PageTitle';
import PageTitleWrapper from 'src/components/PageTitleWrapper';
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Tooltip } from '@mui/material';
import ScheduleIcon from '@mui/icons-material/Schedule';

import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  MenuItem,
  Stack,
  TextField,
  Typography
} from '@mui/material';

import { DataGrid } from '@mui/x-data-grid';

import DownloadIcon from '@mui/icons-material/Download';
import RefreshIcon from '@mui/icons-material/Refresh';


import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import dayjs, { Dayjs } from 'dayjs';

import { get, post } from 'src/services/httpClient.service';
import { authenticationService } from 'src/services/authentication.service';

const AuditRepository = () => {
  const [rows, setRows] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const { vendorId } = authenticationService.getVendorFranchiseIds();
  const [searchTerm, setSearchTerm] = useState('');
  const [reportType, setReportType] = useState('');
  const [reportDate, setReportDate] = useState<Dayjs | null>(dayjs());

  const [pageSize, setPageSize] = useState(100);
  const [scheduleOpen, setScheduleOpen] = useState(false);

  const [selectedFiles, setSelectedFiles] = useState<string[]>([]);

const [scheduleDate, setScheduleDate] = useState<Dayjs | null>(dayjs());
const [fromDate, setFromDate] = useState<Dayjs | null>(dayjs());
const [toDate, setToDate] = useState<Dayjs | null>(dayjs());

  const fileOptions = [
  'SUBSCRIPTION_PACKAGE_DETAILS',
  'SUBSCRIPTION_LOGS',
  'PACKAGE_CHANNEL_COMPOSITION',
  'PACKAGE_CHANNEL_MODIFICATION',
  'USER_ACTIVITY_LOG',
  'MONTHLY_SUBSCRIPTION_REPORT',
  'MONTHLY_SUBSCRIPTION_A_LA_CARTE_REPORT',
  'CHANNEL_AGING_REPORT',
  'PACKAGE_AGING_REPORT',
  'STB_HISTORY_REPORT',
  'STB_RECONCILIATION',
  'PACKAGE_CHANNEL_RECONCILIATION'
];

const handleScheduleLoad = async () => {
  const payload = {
    vendorId: vendorId,
    reports: selectedFiles,
    //date: scheduleDate,
    fromDate: fromDate,
    toDate: toDate
  };
  //scheduleDate?.format('YYYY-MM-DD')
//api/token-reports
  console.log('Payload =>', payload);

  try {
    const response = post(`${process.env.REACT_APP_BASE_API_URL}/api/token-reports/generate`, payload);
    let data = response || [];
    fetchReports()
    console.log(response)
  } catch(error) {
    console.error(error)
  }

  // API Call
  // await post('/api/report/load', payload);

  setScheduleOpen(false);
};

  

  const fetchReports = async () => {
    setLoading(true);

    try {
      

      const response =
        await get(
          `${process.env.REACT_APP_BASE_API_URL}/api/token-reports/vendor/${vendorId}/getTokenReportList`
        );

      const data = response?.data || [];

      const formatted = data.map(
        (item: any, index: number) => ({
          id: index + 1,
          ...item
        })
      );

      setRows(formatted);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }
  
//     const fetchReports = async () => {
//   setLoading(true);

//   try {
//     const data = [];

//     const formatted = data.map((item, index) => ({
//       id: index + 1,
//       ...item
//     }));

//     setRows(formatted);
//   } catch (error) {
//     console.error(error);
//   } finally {
//     setLoading(false);
//   }
// };
  useEffect(() => {
    fetchReports();
  }, []);

  const handlePdfDownload = (
    token: string
  ) => {
    window.open(
      `${process.env.REACT_APP_BASE_API_URL}/api/audit-report/download/${token}?format=pdf`,
      '_blank'
    );
  };

  const handleExcelDownload = (
    token: string
  ) => {
    window.open(
      `${process.env.REACT_APP_BASE_API_URL}/api/audit-report/download/${token}?format=excel`,
      '_blank'
    );
  };

const handleFileDownload = async (token: string) => {
  try {
    const blob = await get(
      `${process.env.REACT_APP_BASE_API_URL}/api/token-reports/vendor/${vendorId}/download/${token}`,
      {
        responseType: "blob"
      }
    );

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = `${token}.zip`;

    document.body.appendChild(link);
    link.click();

    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error(error);
  }
};

  const filteredRows = rows.filter(
    (row: any) => {
      const matchesSearch =
        Object.values(row).some(
          (value: any) =>
            value &&
            value
              .toString()
              .toLowerCase()
              .includes(
                searchTerm.toLowerCase()
              )
        );

      const matchesType =
        !reportType ||
        row.reportType === reportType;

      const matchesDate =
        !reportDate ||
        dayjs(
          row.reportDate
        ).format('YYYY-MM-DD') ===
          reportDate.format(
            'YYYY-MM-DD'
          );

      return (
        matchesSearch &&
        matchesType &&
        matchesDate
      );
    }
  );

 
  const columns = [
    {
      field: 'reportToken',
      headerName: 'Token',
      flex: 1.8
    },
    {
      field: 'fromDate',
      headerName: 'From Date',
      flex: 1.5
    },
    {
      field: 'toDate',
      headerName: 'To Date',
      flex: 1
    },
    {
      field: 'totalReports',
      headerName: 'Total Reports',
      flex: 1.2
    },
    {
      field: 'completedReports',
      headerName: 'Completed Reports',
      flex: 1
    },
    {
      field: 'progressPercentage',
      headerName: 'Process Percentage',
      flex: 1
    },
    {
      field: 'generatedBy',
      headerName: 'generated By',
      flex: 1
    },
    {
      field: 'generatedAt',
      headerName: 'Generated At',
      flex: 1
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 1
    },
    {
  field: 'actions',
  headerName: 'Actions',
  flex: 2,
  sortable: false,
  renderCell: (params: any) => (
    <Stack direction="row" spacing={1} sx={{ py: 1 }}>
      <Button
        size="small"
        variant="contained"
        color="primary"
        startIcon={<DownloadIcon />}
        disabled={params.row.status !== "COMPLETED"}
        onClick={() => handleFileDownload(params.row.reportToken)}
      >
        Download
      </Button>
      {/* <Button
        size="small"
        variant="contained"
        color="error"
        startIcon={<DownloadIcon />}
        onClick={() =>
          handlePdfDownload(params.row.reportToken)
        }
      >
        PDF
      </Button>

      <Button
        size="small"
        variant="contained"
        color="success"
        startIcon={<DownloadIcon />}
        onClick={() =>
          handleExcelDownload(params.row.reportToken)
        }
      >
        Excel
      </Button> */}
    </Stack>
  )
}
  ];

  return (
    <>
      <Helmet>
        <title>
          Token Report
        </title>
      </Helmet>

      <PageTitleWrapper>
        <Box
          sx={{
            display: 'flex',
            justifyContent:
              'space-between',
            alignItems: 'center'
          }}
        >
          <PageTitle
            heading="Token Report"
            subHeading="Manage and download audit reports using generated tokens"
            handleClick={undefined}
          />

          <Button
  variant="contained"
  startIcon={<ScheduleIcon />}
  onClick={() => setScheduleOpen(true)}
>
  Schedule
</Button>
        </Box>
      </PageTitleWrapper>

      

      {/* Filters */}

      <Box sx={{ px: 2 }}>
        <LocalizationProvider
          dateAdapter={AdapterDayjs}
        >
          <Stack
            direction={{
              xs: 'column',
              sm: 'row'
            }}
            spacing={2}
          >
            <TextField
              label="Search"
              size="small"
              value={searchTerm}
              onChange={(e) =>
                setSearchTerm(
                  e.target.value
                )
              }
              sx={{ flex: 1 }}
            />

            <TextField
              select
              size="small"
              label="Report Type"
              value={reportType}
              onChange={(e) =>
                setReportType(
                  e.target.value
                )
              }
              sx={{ minWidth: 250 }}
            >
              <MenuItem value="">
                All Reports
              </MenuItem>

              <MenuItem value="PACKAGE_CHANNEL_COMPOSITION">
                Package Channel
                Composition
              </MenuItem>

              <MenuItem value="PACKAGE_CHANNEL_MODIFICATION">
                Package Channel
                Modification
              </MenuItem>
            </TextField>

            <DatePicker
              label="Report Date"
              value={reportDate}
              onChange={(newValue) =>
                setReportDate(
                  newValue
                )
              }
              slotProps={{
                textField: {
                  size: 'small'
                }
              }}
            />

            
          </Stack>
        </LocalizationProvider>
      </Box>

      {/* Grid */}

      <Box
        sx={{
          height:
            'calc(100vh - 280px)',
          width: '100%',
          p: 2
        }}
      >
        <DataGrid
          rows={filteredRows}
          columns={columns}
          loading={loading}
          pagination
          pageSize={pageSize}
          onPageSizeChange={(
            newPageSize
          ) =>
            setPageSize(
              newPageSize
            )
          }
          rowsPerPageOptions={[
            10,
            20,
            50,
            100
          ]}
          getRowHeight={() => 'auto'}
          sx={{
            border: 2,
            borderColor:
              'rgb(43 44 45)',

            '& .MuiDataGrid-cell':
              {
                alignItems: 'center'
              }
          }}
        />
        
      </Box>
      <Dialog
  open={scheduleOpen}
  onClose={() => setScheduleOpen(false)}
  maxWidth="sm"
  fullWidth
>
  <DialogTitle>
    Schedule Report
  </DialogTitle>

  <DialogContent>
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <Stack spacing={3} sx={{ mt: 1 }}>
      <TextField
  select
  fullWidth
  label="File Names"
  SelectProps={{
    multiple: true
  }}
  value={selectedFiles}
  onChange={(e) =>
    setSelectedFiles(
      typeof e.target.value === 'string'
        ? e.target.value.split(',')
        : e.target.value
    )
  }
>
  {fileOptions.map((file) => (
    <MenuItem key={file} value={file}>
      {file}
    </MenuItem>
  ))}
</TextField>

      {/* <DatePicker
        label="Schedule Date"
        value={scheduleDate}
        onChange={(value) =>
          setScheduleDate(value)
        }
      /> */}
      <DatePicker
        label="From Date"
        value={fromDate}
        onChange={(value) =>
          setFromDate(value)
        }
      />
      <DatePicker
        label="To Date"
        value={toDate}
        onChange={(value) =>
          setToDate(value)
        }
      />
    </Stack>
  </LocalizationProvider>
</DialogContent>
  <DialogActions>
    <Button
      onClick={() =>
        setScheduleOpen(false)
      }
    >
      Cancel
    </Button>

    <Button
      variant="contained"
      onClick={handleScheduleLoad}
      disabled={
  selectedFiles.length === 0 ||
  !scheduleDate
}
    >
      Generate
    </Button>
  </DialogActions>
</Dialog>
    </>
  );
};

export default AuditRepository;